import React from 'react'

import messages from '../../i18n'
import { KoDialog } from '../../components'
import { wizard } from '../../hoc'

export const KoScoring: React.FC = () => (
  <KoDialog title={messages.errors.scoring.title} note={messages.errors.scoring.note} />
)

export default wizard(KoScoring)
